import { render, staticRenderFns } from "./ReservationPatientsSearchPopup.vue?vue&type=template&id=37c79eda&scoped=true&"
import script from "./ReservationPatientsSearchPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationPatientsSearchPopup.vue?vue&type=script&lang=js&"
import style0 from "./ReservationPatientsSearchPopup.vue?vue&type=style&index=0&id=37c79eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c79eda",
  null
  
)

export default component.exports